import { CallFeatureConfigSchema, type CallFeatureConfig } from '@school-journey/shared-types'

import type { ScreenFeatureEntry } from './entry'

/**
 * Global `call`: the Advanced Communications calling module (SCH-616).
 *
 * absentIsEmpty: a paid module, so only a school's own row carries the block;
 * the fleet-default row never does (the schema's docblock in
 * `packages/shared-types/src/schemas/entities/global-features.ts`). A school
 * without it gets `SYSTEM_FEATURE_NOT_FOUND`.
 *
 * Fallback, for a school with no block:
 * - `enabled: false`: an absent block is "module off" for the server
 *   (`apps/backend/src/services/calls/policy/call-capability.ts`) and the app.
 * - `visibleForRoles: []`: required by the schema; the server's backfill for a
 *   feature with no canonical default
 *   (`apps/backend/src/services/config/global-feature-defaults.ts:88-90`).
 * The optional fields stay absent: each reader applies the documented default
 * (video on, 365-day audit window, recording off, sessions on).
 *
 * writeMode `replace`: the panel always saves the whole `call` block (the server also
 * accepts sparse `call` writes, unused here).
 * A recording change always sends the whole `recording` object, so the replace
 * body carries the acknowledgement the server checks (decisions D3).
 */
export const call: ScreenFeatureEntry<'global', 'call', CallFeatureConfig> = {
  resource: 'global',
  wireName: 'call',
  schema: CallFeatureConfigSchema,
  writeMode: 'replace',
  absentIsEmpty: true,
  fallback: {
    enabled: false,
    visibleForRoles: []
  }
}
